import { useEffect, useState } from "react";

import { isBrowser } from "../utils";

export const useMediaQuery = (mediaQuery) => {
  const isBrowserSide = isBrowser();
  const mediaQueryListener = isBrowserSide && window.matchMedia(mediaQuery);
  const [queryMatched, setQueryMatched] = useState(mediaQueryListener.matches);

  useEffect(() => {
    if (isBrowserSide) {
      const handleMediaQueryStatusChange = (e) => {
        setQueryMatched(e.matches);
      };
      mediaQueryListener.addEventListener("change", handleMediaQueryStatusChange);
      return () => mediaQueryListener.removeEventListener("change", handleMediaQueryStatusChange);
    }
  }, [queryMatched, isBrowserSide, mediaQueryListener]);

  return queryMatched;
};
